// docIdInput/parseDocIdInput.js — the document id field of tab 1 of the documents.php filter (#filterDocID) read by its
// field rules (chef list Nr. 6a). Mirror of DocumentIdInput.class.php — the server stays the authority; this copy lets
// the browser stop an invalid input before it is sent. Change both together (tests/js/docIdInput uses the PHP test's
// cases).
//
// Rules: commas, dashes and spaces separate ids; braces, a 3–4-character prefix with colon ("ABC:0000123") and leading
// zeros are dropped; a link "…?doc=123" / "…#doc=123" / ".../file123…" is its id; "[...]" is the open-group marker;
// "[123]" opens the group of document 123 — only the server knows whether there is one ('nogroup'). Anything else is
// 'invalid'.
//
// parseDocIdInput(text) → { ids: string[], problems: [{ part, reason: 'invalid' | 'nogroup' }] }

const LINK_DOC = /^https?:\/\/\S*?[?#&]doc=0*(\d+)(?!\d)\S*$/i;
const LINK_FILE = /^https?:\/\/\S*\/file0*(\d+)[^/\s]*$/i;
const ID = /^(?:[^\s:,{}[\]]{3,4}:)?0*(\d+)$/u;
const GROUP = /^\[\s*0*(\d+)\s*\]$/;
const GROUP_MARKER = '[...]';

const asId = (digits) => String(Number(digits));

export function parseDocIdInput(input) {
    const text = String(input ?? '').trim();
    if (text === '' || text === GROUP_MARKER) {
        return { ids: [], problems: [] };
    }
    if (GROUP.test(text)) {
        return { ids: [], problems: [{ part: text, reason: 'nogroup' }] };
    }

    const ids = [];
    const problems = [];
    // links first: their own dashes and slashes are no separators
    const rest = [];
    for (const part of text.split(/[\s,]+/).filter((p) => p !== '')) {
        const link = LINK_DOC.exec(part) ?? LINK_FILE.exec(part);
        if (link) {
            ids.push(asId(link[1]));
        } else {
            rest.push(part);
        }
    }
    for (const raw of rest.join(',').replace(/-/g, ',').replace(/[{}]/g, '').split(',')) {
        const part = raw.trim();
        if (part === '') {
            continue;
        }
        const id = ID.exec(part);
        if (id) {
            ids.push(asId(id[1]));
        } else {
            problems.push({ part, reason: 'invalid' });
        }
    }
    return { ids, problems };
}
